<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="'FAQs'"
          :heroDescription="'Welcome to the Old Mutual Wills FAQs page, where we provide clear and  concise answers to your most common questions about creating and  managing your Will.'"
          :section="'faqs'"
        />
      </template>
      <template v-slot:faqs>
        <Breadcrumb />
        <TitleRow :html="true" :title="`General FAQs`" :description="''" />
        <Accordion :accordionData="accordionData" :html="true" />
        <div class="section-padding"></div>
      </template>
      <template v-slot:create-my-will>
        <CreateYourWillBanner @createYourWill="signupClicked" />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
  </div>
</template>

<script>
import Accordion from "../../common/Accordion.vue";
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import TitleRow from "../../common/TitleRow.vue";
import Breadcrumb from "../../common/Breadcrumb.vue";
import CreateYourWillBanner from "../CreateYourWillBanner.vue";
import DynamicNavDrawer from "../DynamicNavDrawer.vue";
import DrawerSignUp from "../DrawerSignUp.vue";
import DrawerSignIn from "../DrawerSignIn.vue";
import SuccessSnackbar from "../../common/SuccessSnackbar.vue";
export default {
  name: "FAQs",
  components: {
    Accordion,
    DefaultHeroBar,
    Layout,
    TitleRow,
    Breadcrumb,
    DynamicNavDrawer,
    CreateYourWillBanner,
    DrawerSignUp,
    DrawerSignIn,
    SuccessSnackbar,
  },
  metaInfo() {
    return {
      title: this.whitelabel.metaData.faqs.title,
      meta: [
        {
          name: "description",
          content: this.whitelabel.metaData.faqs.description,
        },
        {
          property: "og:title",
          content: this.whitelabel.metaData.faqs.ogTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.faqs.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.faqs.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.faqs.ogUrl,
        },
        {
          property: "og:description",
          content: this.whitelabel.metaData.faqs.description,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.faqs.ogSiteName,
        },
      ],
    };
  },
  data() {
    return {
      signUpDrawerOpen: false,
      signInDrawerOpen: false,
      showAlert: false,
      alertMessage: null,
    };
  },
  methods: {
    successResetPassword() {
      this.signInDrawerOpen = false;
      this.alertMessage =
        this.whitelabel.authentication.resetPassword.successMessage;
      this.showAlert = true;
    },
    drawerClosed() {
      this.signUpDrawerOpen = false;
    },
    signupClicked() {
      this.$router.push("/register");
    },
    signInDrawerClosed() {
      this.signInDrawerOpen = false;
    },
    loginClicked() {
      this.signUpDrawerOpen = false;
      this.signInDrawerOpen = true;
    },
  },
  computed: {
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "faqs",
          background: "countryPattern",
          fadedRow: true,
          accents: ["green-accent-1", "purple-accent-1"],
          class: "faqs",
        },
        {
          name: "create-my-will",
          class: "faqs",
        },
      ];
    },
    accordionData() {
      return this.whitelabel.FAQs;
    },
  },
};
</script>
